(function () {
    'use strict';

    var controllerId = 'headerController';
    var module = angular.module('inoApp.directives.layout');

    module.directive('layoutHeader', [function () {
        var directive = {
            restrict: 'AE',
            replace: false,
            templateUrl: 'templates/core/layout/header.html',
            controller: controllerId,
            controllerAs: 'headerVm'
        };

        return directive;
    }]);
    
    module.controller(controllerId, ['$rootScope', '$translate', 'common', 'config', 'amMoment', 'tmhDynamicLocale', 'userService', headerController]);

    function headerController($rootScope, $translate, common, config, amMoment, tmhDynamicLocale, userService) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.isSelected = isSelected;
        vm.isCurrent = isCurrent;
        vm.languageKey = config.appLanguage;

        vm.editProfileUrl = config.servicesUrl.editUrl;
        vm.signOutUrl = config.servicesUrl.identity.signOutUrl;
        vm.userIsAuthenticated = userService.isAuthenticated();
        vm.userProfile = userService.currentUser.profile;

        activate();

        function activate() {
            common.handleBusyState([setLanguage(vm.languageKey)], controllerId);
        }

        function isSelected(languageKey) {
            return vm.languageKey === languageKey ? 'selected' : '';
        }

        function isCurrent(languageKey) {
            return vm.languageKey === languageKey;
        }

        function changeLanguage(languageKey) {
            setLanguage(languageKey);
            // Broadcast the language change event so other app parts can take action if they need it.
            $rootScope.$broadcast(config.events.languageChanged, { languageKey: languageKey });
        }

        function setLanguage(languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey + '-CA');
            amMoment.changeLocale(languageKey + '-CA');
            //appConfig.dataTables.changeLanguage(languageKey + '-CA');
            vm.languageKey = languageKey;
        }
    };
})();